import { AuthTokenService } from '@/core/services/auth-token.service';
import { UserStoreService } from '@/core/stores/user-store.service';
import { AuthApi } from '@/features/auth/services/auth.api';
import { inject, Injectable } from '@angular/core';
import { tap } from 'rxjs';
import { CryptoJsService } from './crypto-js.service';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    constructor(
        private readonly tokenService: AuthTokenService,
        private readonly userStore: UserStoreService,
        private readonly authApi: AuthApi
    ) {}

    cryptoJsService = inject(CryptoJsService);

    login(username: string, password: string, rememberMe: boolean) {
        return this.authApi.login(username, this.cryptoJsService.encryptUsingAES256(password)).pipe(
            tap((response) => {
                this.tokenService.setTokens(
                    {
                        access_token: response.accessToken!,
                        refresh_token: response.refreshToken!,
                        expires_in: response.expiresIn!
                    },
                    rememberMe
                );

                this.userStore.setUser(response.userProfile);
            })
        );
    }

    forgotPassword(email: string) {
        return this.authApi.forgotPassword(email);
    }

    changePassword(email: string, oldPassword: string, newPassword: string, confirmPassword: string) {
        return this.authApi.changePassword(email, oldPassword, newPassword, confirmPassword);
    }

    getMenuItem(){
        
    }

    logout() {
        this.clearSession();
    }

    clearSession() {
        this.tokenService.clearTokens();
        this.userStore.clearUser();
    }
}
